import { useDynamicContentLoader } from "../../../hooks/useDynamicContentLoader/useDynamicContentLoader";
import { DynamicContentRenderer } from "../../DynamicContentRenderer/DynamicContentRenderer";
import style from "./ExpertGroupsForApp.module.scss";

const ExpertGroupsForAppMode = ({ link }) => {
  const { htmlContent, isLoading, error } = useDynamicContentLoader({
    contentPattern: "_egm.dita",
    link,
  });

  return (
    <>
      <DynamicContentRenderer
        htmlContent={htmlContent}
        isLoading={isLoading}
        error={error}
        loadingMessage="Loading Expert group..."
        containerClass={style.acknowledgementsContainer}
        contentClass={style.acknowledgementsContent}
      />
    </>
  );
};

export default ExpertGroupsForAppMode;
